const defaultState = {
  recaptchaSiteKey: undefined,
};

export default function configReducer(state = defaultState) {
  return state;
}
